import { DayHeading, DayMap, DaySection, Slab } from "./day";

/** The course map section: the app's green map, drawing itself in when scrolled to. */
export function CourseMapSection() {
  return (
    <DaySection id="course" label="Your course map" tone="tint">
      <div className="grid items-center gap-12 lg:grid-cols-[1fr_1fr] lg:gap-16">
        <div>
          <DayHeading
            eyebrow="Your course map"
            title="See how far you’ve come, and choose where to go next."
            intro="Your course grows one lesson at a time, from what you’ve learned and what you asked along the way. No fixed syllabus, so it never spends your time on things you don’t need."
          />
          <ul className="mt-8 flex flex-col gap-3 text-[15px] leading-relaxed text-[#6B6780]">
            <li>
              <span className="font-black text-[#1C1A27]">Next</span> keeps you moving toward your goal.
            </li>
            <li>
              <span className="font-black text-[#6B4EFF]">Sideways</span> and <span className="font-black text-[#6B4EFF]">Go deeper</span> follow your curiosity when something catches your eye.
            </li>
            <li>Or ask for anything, and it becomes your next lesson.</li>
          </ul>
        </div>
        <Slab className="mx-auto w-full max-w-[420px] overflow-hidden p-2" edge="border-[#B9D199]">
          <DayMap />
        </Slab>
      </div>
    </DaySection>
  );
}
